import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { ServicePlan } from 'src/features/servicePlans/utils/types';
import { ServicePlanFormSchemaValues } from 'src/features/servicePlans/utils/formSchema';

const RESOURCE = '/subscriptions/service-plan/';

type MutationFnType = typeof mutationFn;
const mutationFn = (data: ServicePlanFormSchemaValues): Promise<ServicePlan> => {
    return axios.post(formatResourcePath(RESOURCE), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateServicePlan };
